import { useQuery } from '@tanstack/react-query';

import { getGanttData } from '@entities/gantt/api/getGanttData';
import { IGanttData } from '@entities/gantt/model/types';
import { keysToCamel } from '@shared/helpers';
import { IDataResponse } from '@shared/model/types/dataResponse.inteface';

export const useGetGanttDataQuery = () => {
    const {
        isLoading: isGetGanttDataLoading,
        isFetching,
        data: ganttData,
        isSuccess,
        refetch,
    } = useQuery<IDataResponse<IGanttData>, Error, IGanttData>({
        queryKey: ['getEstimateGanttData'],
        queryFn: getGanttData,
        staleTime: 1000 * 60 * 5,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        enabled: false,
        select: (response: IDataResponse<IGanttData>) => keysToCamel(response.data),
    });

    return { isGetGanttDataLoading, isFetching, isSuccess, ganttData, refetch };
};
